import { render, staticRenderFns } from "./LoginV3Mobile.vue?vue&type=template&id=2b0565e2"
import script from "./LoginV3Mobile.vue?vue&type=script&lang=js"
export * from "./LoginV3Mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports